module.exports = "/_next/static/images/Denis_Mezer-dd15e16c1af8bb402e35ef0c40c478fa.webp";